import {
  FormAddon,
  FormAdyen,
  FormCeca,
  FormCybersource,
  FormGetnet,
  FormHotelpay,
  FormMercadopago,
  FormMews,
  FormNuvei,
  FormPaybyrd,
  FormPaycomet,
  FormPaymob,
  FormPaynopain,
  FormPaypal,
  FormRedsys,
  FormReduniq,
  FormShift4,
  FormStripe,
  FormWorldline,
} from '../components';

const MODALS = {
  1: FormAddon,
  3: FormPaycomet,
  5: FormAdyen,
  6: FormStripe,
  7: FormHotelpay,
  8: FormPaybyrd,
  9: FormNuvei,
  10: FormGetnet,
  11: FormShift4,
  12: FormMews,
  13: FormCybersource,
  14: FormMercadopago,
  15: FormReduniq,
  16: FormPaymob,
  17: FormPaynopain,
  18: FormRedsys,
  19: FormPaypal,
  20: FormWorldline,
  21: FormCeca,
};

export { MODALS };
